module.exports = __webpack_public_path__ + "static/media/50_tn.154b59e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/50_tn.jpg
// module id = 538
// module chunks = 0